var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_347_247",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_347_247",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnElEQVR4nO2Zy2sUQRDGBw++XxfFg+LjpDc9qDEReub7epZVNxCFPakXRXzgSY03iYIeVTwKvg6C/0EwOXvQxOhBFKKXRKLoycdBExKIFM4ulWZ2M7vZYRadgoZlarq6f1Vd3dWznpdLLrnk8k9JR0fHMt/3uwCUs2i+73fJHBYE4fv+XgDjJGczbmMA9jQdiTaBmK3AGGOWNgxird3fBpOf1U2WWcMgsj61ES8joZqDzKlhAzlIi4V5RCLJl1a7Ly1kdLKz1SDt0JCDMPsoMI9IczkyAeApgMkYLw4BGI55Pil9pG9Se0g5RyastWukTxAEB52B71fskXzg9CvKc+kL4FNCe+XUQMRzlT4yAUd/Qtk7qXXFYnG1ghxIYg8pg0yK5yLP3nF0r8Iw3EpyG4DXTt/bAmOtPQRgKqG9cmog+a7F/3j7DYLgeCtARiR5Y3YfafdEJznhePBHEASXSPbK7xbA/CZ5o1wuL24axBizRemG9TlReR4lth64V/W53MLovDDGbGgKRCZZ0ZF8qUCG1fNtCwD5QvK6fIIKw3C9eN0YsxFAD4DHJKedaL8rFovrGgaRZROdBQ9jJvFAdO4WK8tJACKIn3WS+JYxZmVl7CAINgPo1p9/rLU7JPpO38G+vr5FDYGk1QCc0eMWCoVNCnrA/dZGsl/3t9aeyhxEIuGOa609ovQzrl4OUQCj6p1PdZM/bRAAXzs7O1fNN64XIyRLjq3DiUEA3Iy8cUBXpdHvouik7HAmPCK7nTR3a5bETjKuV3t+73WOJgZppsirVzSS3LcQEM512tvEIBIJeW6MWVur7JYC0Jls1VMAHjmOWZfw/FpbA+Sceu9bIyCyhAYciGrCRbqpGN2wPncUyJKE4w7FwQA4pueWGKTVTbbZuHHN34gPuc4olUrLnfldVPrxmiDyCT/lXaun1tgmHua0fofkE6V7VhMkOnzGUgR5XHNwrwqja7ruii4MwxUAvit7V+vZkvDtSRFmulAobK83fqlUWm6tPashomhc0bbCMNxZFyTyzNJW/Rkq94moFK8mcqN/dJLcTfKXAhn0shC5TziR6ddn1HwQAD4rR8yQ3OVlIVIXkXzu5Muou3y0SE5Ey0lHYs41IRORS5GcxjF580EKSQDnSR4leUF2JyexK/B3vXYQOdllfTex281kHglX5FIk94m4aoHxTcCzyYkkInkjpbjcPgG8kaUk5Q6Aj3LYkbw23xb7B03Z/0eNN+kJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.895eb374ee76d67663ca9b42fcc9f544.svg";
export { ForwardRef as ReactComponent };